import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {IExternalIDUser} from 'app/types/Shared';

export enum validEmailStatusMessages {
  VALID_EMAIL = 'Valid email',
  INVALID_EMAIL = 'Invalid email',
  ALREADY_REGISTERED = 'User already registered',
  INVALID_CAPTCHA = 'Invalid captcha',
  EMAILEXIST = 'Email already exists',
}

export enum submitFormStatusMessages {
  FAILED = 'Failed',
  SUCCESS = 'Success',
  EMAILEXIST = 'Email already exists',
  INVALID_CAPTCHA = 'Invalid captcha',
}

interface ValidateUserPayload {
  email: string;
  captcha_token: string;
}

interface ValidateUserResponse {
  status: validEmailStatusMessages;
  message: string;
}

interface RegistrationFormResponse {
  status: submitFormStatusMessages;
  message: string;
}

interface RegistrationFormPayload extends IExternalIDUser {
  captcha_token: string;
}

interface UserLoginFormPayload {
  email: string;
  token: string;
}

interface UserLoginFormResponse {
  message: string;
}

export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASEURL || 'http://localhost:3500',
  }),
  tagTypes: ['registrationApi'],
  endpoints(builder) {
    return {
      /////////// CRO Registration Routes ///////////
      //use post to send and validate capthca as well as confirm user email is allowed to access elevate
      validateUser: builder.query<ValidateUserResponse, ValidateUserPayload>({
        query: (params) => {
          console.log('email', params.email);
          return {
            url: `validateEmail/${params.email}`,
            method: 'GET',
            headers: {
              Authorization: params.captcha_token,
            },
          };
        },
      }),
      //use post to send user registration info and validate captcha token
      submitRegistrationForm: builder.mutation<RegistrationFormResponse, RegistrationFormPayload>({
        query: (body) => {
          return {
            url: `submitForm/`,
            body,
            method: 'POST',
          };
        },
      }),
      userLogin: builder.mutation<UserLoginFormResponse, UserLoginFormPayload>({
        query: (body) => {
          const {token, ...rest} = body;
          return {
            url: `userLogin/`,
            body: rest,
            method: 'POST',
            headers: {
              Authorization: token,
            },
          };
        },
      }),
    };
  },
});

export const {useLazyValidateUserQuery, useSubmitRegistrationFormMutation, useUserLoginMutation} = registrationApi;
